/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_tip_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add the tip to the bill to get the total, then divide the total by the number of people to find each person's share.`)
};

const es_pct_tip_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suma la propina a la cuenta para obtener el total, luego divide el total entre el número de personas para saber la parte de cada una.`)
};

const de_pct_tip_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Addiere das Trinkgeld zur Rechnung, um den Gesamtbetrag zu erhalten, und teile ihn dann durch die Anzahl der Personen, um den Anteil jeder Person zu ermitteln.`)
};

const nl_pct_tip_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tel de fooi bij de rekening op voor het totaal, en deel het totaal daarna door het aantal personen om ieders aandeel te krijgen.`)
};

const fr_pct_tip_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajoutez le pourboire à l'addition pour obtenir le total, puis divisez le total par le nombre de personnes pour trouver la part de chacune.`)
};

const it_pct_tip_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi la mancia al conto per ottenere il totale, poi dividi il totale per il numero di persone per trovare la quota di ciascuno.`)
};

const pt_br2_pct_tip_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some a gorjeta à conta para obter o total, depois divida o total pelo número de pessoas para encontrar a parte de cada uma.`)
};

const pt_pct_tip_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some a gorjeta à conta para obter o total, depois divida o total pelo número de pessoas para encontrar a parte de cada uma.`)
};

const ja_pct_tip_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会計にチップを加えて合計額を求め、その合計額を人数で割ると一人当たりの負担額が分かります。`)
};

const zh_pct_tip_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将小费加到账单上得到总额，再用总额除以人数得到每人应付的份额。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_tip_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_tip_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_tip_faq2_a", locale)
	if (locale === "en") return en_pct_tip_faq2_a(inputs)
	if (locale === "es") return es_pct_tip_faq2_a(inputs)
	if (locale === "de") return de_pct_tip_faq2_a(inputs)
	if (locale === "nl") return nl_pct_tip_faq2_a(inputs)
	if (locale === "fr") return fr_pct_tip_faq2_a(inputs)
	if (locale === "it") return it_pct_tip_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_pct_tip_faq2_a(inputs)
	if (locale === "pt") return pt_pct_tip_faq2_a(inputs)
	if (locale === "ja") return ja_pct_tip_faq2_a(inputs)
	return zh_pct_tip_faq2_a(inputs)
};